export enum PaymentMethodType {
  Card = "Card",
  Bank = "Bank",
}
export enum PaymentMethodPriority {
  Backup = "Backup",
  Primary = "Primary",
  None = "None",
}
